import { apiService } from './api.service';

class AIContextService {
  private conversationHistory: string[] = [];
  private readonly MAX_HISTORY = 10;

  async getContextSuggestion(gesture: string): Promise<string | null> {
    try {
      const response: any = await apiService.getAIContext(gesture, this.conversationHistory);
      const context = response.context;
      
      // Add to history
      this.addToHistory(gesture);
      this.addToHistory(context);
      
      return context;
    } catch (error) {
      console.error('Failed to get AI context:', error);
      return null;
    }
  }

  async completeSentence(partialText: string): Promise<string | null> {
    try {
      const response: any = await apiService.completeSentence(partialText, this.conversationHistory);
      return response.completion;
    } catch (error) {
      console.error('Failed to complete sentence:', error);
      return null;
    }
  }

  addToHistory(text: string) {
    this.conversationHistory.push(text);
    
    // Keep only recent history
    if (this.conversationHistory.length > this.MAX_HISTORY) {
      this.conversationHistory = this.conversationHistory.slice(-this.MAX_HISTORY);
    }
  }

  clearHistory() {
    this.conversationHistory = [];
  }

  getHistory(): string[] {
    return [...this.conversationHistory];
  }
}

export const aiContextService = new AIContextService();
